"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ButtonsWrap = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  text-align: center;\n  margin-top: 2rem;\n\n  button {\n    margin-right: 1rem;\n  }\n"], ["\n  align-items: center;\n  text-align: center;\n  margin-top: 2rem;\n\n  button {\n    margin-right: 1rem;\n  }\n"])));
var ModalButtonsWrap = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(ButtonsWrap, null, children);
};
exports.default = ModalButtonsWrap;
var templateObject_1;
